import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import { motion } from 'framer-motion';
import './AITechStack.css';

const technologies = {
  frameworks: [
    { name: 'TensorFlow', icon: '/assets/tech-logos/tensorflow.svg' },
    { name: 'PyTorch', icon: '/assets/tech-logos/pytorch.svg' },
    { name: 'Scikit-learn', icon: '/assets/tech-logos/scikit-learn.svg' },
    { name: 'Keras', icon: '/assets/tech-logos/keras.svg' }
  ],
  languages: [
    { name: 'Python', icon: '/assets/tech-logos/python.svg' },
    { name: 'R', icon: '/assets/tech-logos/r-lang.svg' },
    { name: 'Julia', icon: '/assets/tech-logos/julia.svg' }
  ],
  cloud: [
    { name: 'AWS SageMaker', icon: '/assets/tech-logos/aws-sagemaker.svg' },
    { 
      name: 'Google AI', 
      icon: 'https://www.gstatic.com/lamda/images/favicon_v1_150160cddff7f294ce30.svg'  // Using Google's AI/ML product icon
    },
    { name: 'Azure ML', icon: '/assets/tech-logos/azure-ml.svg' }
  ]
};

const categories = [
  { 
    id: 'frameworks', 
    title: 'AI & ML Frameworks', 
    subtitle: 'Industry-standard frameworks for building and training models' 
  },
  { 
    id: 'languages', 
    title: 'Programming Languages', 
    subtitle: 'Specialized languages for AI and data science' 
  },
  { 
    id: 'cloud', 
    title: 'Cloud AI Services', 
    subtitle: 'Enterprise-grade AI infrastructure and services' 
  }
];

const AITechStack = () => {
  return (
    <section className="tech-stack">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="tech-header"
        >
          <Typography variant="h2" className="section-title" gutterBottom>
            AI Technologies We Use
          </Typography>
          <Typography variant="subtitle1" className="sd-ts-section-subtitle" gutterBottom>
            State-of-the-art tools and frameworks for AI development
          </Typography>
        </motion.div>

        <Grid 
          container 
          spacing={3} 
          sx={{ 
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch'
          }}
        >
          {categories.map((category, categoryIndex) => (
            <Grid 
              item 
              xs={12} 
              sm={12} 
              md={4} 
              key={category.id}
              sx={{ 
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: categoryIndex * 0.1 }}
                style={{ height: '100%' }}
              >
                <Box 
                  className="category-container" 
                  sx={{ 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography variant="h5" className="ts-category-title">
                    {category.title}
                  </Typography>
                  <Typography variant="subtitle2" className="category-subtitle">
                    {category.subtitle}
                  </Typography>
                  <Grid 
                    container 
                    spacing={2} 
                    className="tech-grid"
                    sx={{ flexGrow: 1 }}
                  >
                    {technologies[category.id].map((tech, techIndex) => (
                      <Grid item xs={6} sm={6} key={tech.name}>
                        <motion.div
                          className="tech-item"
                          whileHover={{ y: -5 }}
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.3, delay: techIndex * 0.05 }}
                        >
                          <img
                            src={tech.icon}
                            alt={tech.name}
                            className="tech-icon"
                          />
                          <Typography variant="body2" className="tech-name">
                            {tech.name}
                          </Typography>
                        </motion.div>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default AITechStack; 